import EmptyCart from './empty-cart'

export default EmptyCart
